import { render, staticRenderFns } from "./detailChange.vue?vue&type=template&id=694a8ae8&scoped=true&"
import script from "./detailChange.vue?vue&type=script&lang=js&"
export * from "./detailChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694a8ae8",
  null
  
)

export default component.exports